import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit, ViewChild } from "@angular/core";
import swal from "sweetalert2";
import { UserServiceService } from "../services/user-service/user-service.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { PaginationComponent } from "../layout/pagination/pagination.component";

@Component({
  selector: "app-broker-wallet",
  templateUrl: "./broker-wallet.component.html",
  styleUrls: ["./broker-wallet.component.css"],
})
export class BrokerWalletComponent implements OnInit {
  selectedWallet: any = {};
  filter_expand = false;
  filterForm: FormGroup;
  brokerWallet: any;
  brokers: any;
  searchedBrokers: any;
  teams: any;
  projects: any;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile")) || {};
  current_balance: any;
  has_filter_data: boolean = false;
  current_commission: any;
  current_wallet_id: any;
  excel: any;
  active_tab = "all";
  ambassadors: any;
  searchedAmbassadors: any;
  incentives: any;
  searchedIncentives: any;
  check_all: boolean = false;
  page = 1;
  page_length = 15;

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: FormBuilder,
    private slimLoadingService: SlimLoadingBarService,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    if (this.userData.role !== "Property Consultant") {
      this.getBrokers();
      this.getAmbassadors();
      this.getBrokerIncentives();
    }
    this.getProjects();

    this.setActiveTab("all");
    this.getBrokersWallet();
  }

  getBrokerIncentives() {
    this.slimLoadingService.start();
    this.userService.getBrokerIncentives({ paginate: 0 }).subscribe(
      (data: any) => {
        this.incentives = data;
        this.searchedIncentives = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingService.complete()
    );
  }

  setActiveTab(tab) {
    this.active_tab = tab;
    let userId = "";
    switch (tab) {
      case "me": {
        userId = this.userData.id;
      }
    }
    if (this.userData.role == "Admin" || this.userData.role === "CFO") {
      this.adminCreateForm(userId);
    } else {
      this.userCreateFilterForm(userId);
    }
    this.getBrokersWallet();
    this.page = 1;
    this.page_length = 15;
  }

  adminCreateForm(userId?) {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      team_id: [""],
      project_ids: [[]],
      commissioned_for: [userId || null],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      direction: ["external"],
      user_type: [""],
      is_approve: [""],
    });
  }

  get userType() {
    return this.filterForm.get("user_type").value;
  }

  getAmbassadors() {
    this.slimLoadingService.start();
    let params = {
      paginate: false,
    };
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        this.ambassadors = data;
        this.searchedAmbassadors = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingService.complete()
    );
  }

  userCreateFilterForm(userId) {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      project_ids: [[]],
      commissioned_for: [userId || ""],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      direction: ["external"],
    });
  }

  getBrokersWallet() {
    let payload = this.filterForm.value;
    this.slimLoadingService.start();
    this.userService.getBrokersWallet(payload).subscribe(
      (res: any) => {
        this.brokerWallet = res;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  getBrokers() {
    this.slimLoadingService.start();
    this.userService.getBrokersWallets().subscribe(
      (res: any) => {
        this.brokers = res;
        this.searchedBrokers = res;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  deleteCommission(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this commission!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingService.start();
        this.userService.deleteCommission(id).subscribe(
          (res: any) => {
            this.getWallet();
            swal("success", "Deleted commission successfully!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingService.complete();
          }
        );
      }
    })
  }

  getProjects() {
    this.slimLoadingService.start();
    this.reservationService.getProjects().subscribe(
      (data) => {
        this.projects = data;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.slimLoadingService.complete();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getWallet() {
    let payload = this.filterForm.value;
    payload.page = this.page;
    payload.page_length = this.page_length;
    this.slimLoadingService.start();
    this.userService.filterWallet(payload).subscribe(
      (res: any) => {
        this.brokerWallet = res;
        this.slimLoadingService.complete();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  changePageLength(page_length) {
    this.page_length = page_length;
    this.page = 1;
    this.getWallet();
  }

  pageChange(page) {
    this.page = page;
    this.getWallet();
  }

  resetFilter() {
    this.setActiveTab(this.active_tab);
  }

  payWallet(id) {
    this.slimLoadingService.start();
    this.userService.payWallet(id).subscribe(
      (res: any) => {
        this.slimLoadingService.complete();
        this.getBrokersWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  exportWallet() {
    let data = this.filterForm.value;
    data.excel = 1;
    this.userService.exportWallet(data).subscribe(
      (res: any) => {
        window.open(res.url);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  approveWallet(id) {
    const payload = {
      ids: [id],
    };
    this.slimLoadingService.start();
    this.userService.approveWallet(payload).subscribe(
      (res: any) => {
        swal("Success", "approved successfully", "success");
        this.slimLoadingService.complete();
        this.getBrokersWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  onUserTypeChange(event) {
    this.filterForm.get("commissioned_for").patchValue("");
  }

  searchedCommissionedForChange(search, type) {
    switch (type) {
      case "brokers":
        this.searchedBrokers = this.brokers.filter((broker) =>
          broker.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case "ambassadors":
        this.searchedAmbassadors = this.ambassadors.filter((ambassador) =>
          ambassador.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
      case "incentives":
        this.searchedIncentives = this.incentives.filter((incentive) =>
          incentive.name.toLowerCase().includes(search.toLowerCase())
        );
        break;
    }
  }

  changeCommissionValue(modal) {
    const payload = {
      wallet_id: this.selectedWallet.id,
      commission: this.selectedWallet.commission,
    };
    this.slimLoadingService.start();
    this.userService.editCommission(payload).subscribe(
      (res: any) => {
        this.closeModal(modal);
        this.slimLoadingService.complete();
        this.getWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  onCheckAllToggle(event) {
    if (this.brokerWallet.wallets) {
      this.check_all = event;
      this.brokerWallet.wallets.data.forEach((e) => {
        if (this.check_all) {
          e.checked = true;
        } else {
          e.checked = false;
        }
      });
    }
  }

  approveWalletSelected() {
    let selectedWallets = this.brokerWallet.wallets.data.filter((list) => {
      if (list.checked == true) return true;
    });
    if (!selectedWallets.length) {
      swal("warning", "There is no selected Cheques");
      return;
    }
    swal({
      title: "Are you sure?",
      text: "You will approve!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it",
    })
      .then((result) => {
        if (result.value) {
          const payload = {
            ids: selectedWallets.map((doc) => doc.id),
          };
          this.slimLoadingService.start();
          this.userService.approveWallet(payload).subscribe(
            (res: any) => {
              swal("Success", "approved successfully", "success");
              this.slimLoadingService.complete();
              this.setActiveTab(this.active_tab);
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingService.complete();
            }
          );
        } else if (result.dismiss) {
          swal("Cancelled", "", "error");
        }
      })
      .catch((err) => {
        swal("Cancelled", "", "error");
      });
  }

  closeModal(modal: any) {
    modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker-wallet/broker-wallet.component.ts